(ns ycweb.app.pos.aftersales.aftersales
  (:require
   [clojure.set :as set]
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.pos.menu :as menu]
   [ycweb.app.pos.payment :as payment]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.cards :as cards]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.header :as header]
   [ycweb.components.slats :as slats]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(def aftersales-steps
  (forms/setup-steps
    [{:key :start :title "Get started"}
     {:key :customer :title "Find customer"}
     {:key :orders :title "Select order"}
     {:key :items :title "Select products to return"}
     {:key :gift-check :title "Choose return type"}
     {:key :details :title "Customer details"}
     {:key :summary :title "Confirm"}
     {:key :auth-payments :title "Auth payments"}
     {:key :payments :title "Payments"}
     {:key :print :title "Print slip"}
     {:key :finished :title "Finish"}]))

(defn returns-lookup [app-atom]
  (when-not (= (get-in @app-atom [:aftersales :customer :name])
              (get-in @app-atom [:aftersales :scan]))
    (swap! app-atom update :aftersales dissoc :lookup)
    (toaster/open-subtle-progress app-atom)
    (comms/send :pos/return-order-list
      {:lookup (get-in @app-atom [:aftersales :customer :name])
       :no-error-reply true})))

(defmethod comms/receive :pos/return-order-list [app-atom e]
  (when (= (:lookup e) (get-in @app-atom [:aftersales :customer :name]))
    (do
      (toaster/close-subtle-progress app-atom)
      (swap! app-atom assoc-in [:aftersales :customer :lookup]
        (dissoc (merge (:user e) e) :user)))))

(defonce customer-lookup-lifecycle-listener
  (cmn/lifecycle-listener :aftersales/lookup :setup
    (fn [app-atom]
      (cmn/debounce-in app-atom [:aftersales :customer :name]
        500
        #(if (and (>= (count %) 2))
           (returns-lookup app-atom)
           (toaster/close-subtle-progress app-atom))))))

(rum/defc aftersales-screen-wrapper
  [app-atom progress-step body foot-note call-to-action]

  (let [menu-atom (rum/cursor app-atom :menu)]
    [:div.page-body
     (header/header app-atom "Returns & Repairs" {})
     (header/menu-overlay menu-atom)
     (header/menu app-atom (menu/select-menus app-atom))

     (into
       [:div.page-body__main-content
        [:div.section
         (forms/progress-steps
           (forms/progress-step aftersales-steps progress-step))]]
       body)

     (into
       [:aside.page-body__footer]
       foot-note)
     call-to-action]))

(rum/defc aftersales-type-blocks [app-atom]
  [:nav
   {:class (u/bem :section [:medium])}
   [:h2.u-text-center
    {:class (u/bem :heading [:standard])}
    "What would you like to do?"]
   [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
    {:style {:height "auto"}
     :on-click
     #(grid/dispatch-action app-atom :returns/select {:type :return})}

    [:span.tile__content
     [:span.tile__icon-wrapper
      [:i.tile__icon
       {:class (u/bem :icon [:2-2 :return :large :block])}]]
     [:span.tile__text "Return"]]]
   [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
    {:style {:height "auto"}
     :on-click
     #(grid/dispatch-action app-atom :returns/select {:type :repair})}

    [:span.tile__content
     [:span.tile__icon-wrapper
      [:i.tile__icon
       {:class (u/bem :icon [:2-2 :wrench :large :block])}]]
     [:span.tile__text "Repair"]]]])

(defmethod grid/action :returns/select [app-atom aftersale _]
  (swap! app-atom assoc :aftersales {:type (:type aftersale)})
  (t/transition-next app-atom :returns/customer))


(rum/defc aftersales-policy [app-atom]
  [:aside.u-text-center
   {:class (u/bem :section [:medium])}
   [:a
    {:href "#", :class (u/bem :button [:text-link :text-default])
     :on-click
     #(grid/dispatch-action app-atom :returns/policy {})}
    "Returns & Repairs Policy"]])

(defmethod grid/action :returns/policy [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/returns-policy {})
  (t/transition-next app-atom :returns/policy))

(defmethod comms/receive :pos/returns-policy [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:aftersales :policy] e))

(rum/defc aftersales-screen-start
  [app-atom]
  (aftersales-screen-wrapper app-atom :start
    [[:div.section
      (aftersales-type-blocks app-atom)
      (aftersales-policy app-atom)]]
    []
    []))

(defmethod flow/render-screen :returns [app-atom _]
  (aftersales-screen-start app-atom))

(rum/defc aftersales-policy-screen < rum/reactive
  [app-atom]
  (let [policy-atom (rum/cursor-in app-atom [:aftersales :policy])
        article (rum/react policy-atom)]
    (aftersales-screen-wrapper app-atom :start
      (if article
        [[:div.section
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           (:title article)]]
         [:div.section
          {:dangerouslySetInnerHTML
           {:__html
            (->
              (:body article)
              (str/replace #"[<]a " "<i ")
              (str/replace #"[<][/]a[>]" "</i>"))}}]]

        [[:div.section
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "Loading..."]]])

      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :returns/policy [app-atom _]
  (aftersales-policy-screen app-atom))

(rum/defc aftersales-screen-customer < rum/reactive
  [app-atom]
  (let [customer-atom (rum/cursor-in app-atom [:aftersales :customer])
        found (cmn/curact customer-atom [:lookup :found])]
    (aftersales-screen-wrapper app-atom :customer
      [[:div.section
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "Enter order number or customer email"
           [:span.u-hidden-from-view " "]
           [:span.heading__subtext "or scan QR code on original till slip"]]
          (forms/input "" "e.g. YC123456789" (rum/cursor customer-atom :name)
            {:hint "e.g. YC123456789 or jane.smith@domain.com"
             :type :barcode})]
         [:div
          {:class (u/bem :section [:standard])}
          (when (cmn/curact customer-atom :lookup)
            (case found
              :customer
              (feedback/feedback :success "User Found"
                (str "Press Next to view orders linked to " (cmn/curact customer-atom [:lookup :email])))

              :order
              (feedback/feedback :success "Order Found"
                (str "Press Next to view the items for order " (cmn/curact customer-atom [:lookup :ref])))

              (feedback/feedback :error "No order or user found"
                "Please enter the complete order number or complete email address")))]]]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn
         (fn []
           (grid/dispatch-action app-atom
             (case found
               :customer :returns/show-customer-orderlist
               :order :returns/select-order
               :returns/case-not-found)
             {:order (first (get-in @app-atom [:aftersales :customer :lookup :orders]))}))}))))

(defmethod grid/action :returns/show-customer-orderlist [app-atom _ _]
  (t/transition-next app-atom :returns/orders)
  (swap! app-atom update-in [:aftersales :customer]
    (fn [l] (assoc (:lookup l) :name (:name l) :lookup (:lookup l)))))

(defmethod grid/action :returns/select-order [app-atom {:keys [order]}]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom
    (fn [s]
      (-> s
        (assoc-in [:aftersales :order] order)
        (assoc-in [:aftersales :uuid] (u/rand-uuid)))))
  (comms/send :pos/return-item-list {:order {:id (:id order)}}))

(defmethod comms/receive :pos/return-item-list
  [app-atom {:keys [items discounts totals item-reasons reason->destination payment-types] :as e}]
  (let [customer-details @(rum/cursor-in app-atom [:aftersales :customer :lookup])]
    (toaster/close-subtle-progress app-atom)
    (t/transition-next app-atom :returns/items)

    (swap! app-atom update :aftersales
      (fn [a]
        (->
          a
          (update :order
            #(assoc %
               :items (vec items)
               :discounts discounts
               :totals totals
               :payment-types payment-types))
          (update :customer
            merge {:firstname (:firstname customer-details)
                   :lastname (:lastname customer-details)
                   :email (:email customer-details)
                   :cell (:cell customer-details)})
          (assoc
            :item-reasons item-reasons
            :reason->destination reason->destination))))))

(defmethod flow/render-screen :returns/customer [app-atom _]
  (aftersales-screen-customer app-atom))

(defmethod flow/barcode-dispatch-screen :returns/customer [_ app-atom scan]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom assoc-in [:aftersales :scan] scan)
  (comms/send :pos/return-customer-scan {:scan scan}))

(defmethod comms/receive :pos/return-customer-scan-result [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom
    (fn [state]
      (-> state
        (update :aftersales dissoc :scan)
        (assoc-in [:aftersales :customer :name]
          (case (:found e)
            :customer (get-in e [:user :email])
            :order (:ref (first (:orders e)))
            ""))
        (assoc-in [:aftersales :customer :lookup]
          (dissoc (merge (:user e) e) :user))))))

(defn order-displayname [order]
  (u/capitalize-words
    (or
      (cond
        (= :shop (:type order))
        (:storename order)

        :else
        (:receivername order))
      "")))

(rum/defc aftersales-screen-orders < rum/reactive
  [app-atom]
  (let [customer-atom (rum/cursor-in app-atom [:aftersales :customer])]
    (aftersales-screen-wrapper app-atom :orders
      [[:div
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           (if (cmn/curact customer-atom :firstname)
             (str "Orders for " (cmn/curact customer-atom :firstname) " " (cmn/curact customer-atom :lastname))
             "Orders")
           [:span.u-hidden-from-view " - "]
           [:span.heading__subtext (cmn/curact customer-atom :email)]]]
         (map
           (fn [o]
             (let [display-name (order-displayname o)]
               (slats/order-slat
                 (:type o) (:ref o) (:dateplaced o) display-name (:itemqty o) (/ (:total o) 100)
                 {:on-click
                  #(grid/dispatch-action app-atom :returns/select-order {:order o})})))
           (cmn/curact customer-atom :orders))]]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :returns/orders [app-atom _]
  (aftersales-screen-orders app-atom))

(defmethod flow/barcode-dispatch-screen :returns/orders [_ app-atom scan]
  (grid/dispatch-action app-atom :returns/order-scan {}))

(defmethod grid/action :returns/order-scan [app-atom {:keys [scan]}]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/return-order-scan
    {:scan scan
     :userid (get-in @app-atom [:aftersales :customer :id])}))

(defmethod comms/receive :pos/return-order-scan-result [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (if (empty? (:orders e))
    (toaster/open-toast app-atom :error "No orders found with this item" {})
    (swap! app-atom assoc-in [:aftersales :customer :orders] (:orders e))))



;; ========= Returns Order Screen  ===========================
(defn contains-all? [m ks]
  (empty?
    (set/difference
      (set ks)
      (set (keys m)))))

(defn get-selected-items [items]
  (vec (filter #(= (:selected %) true) items)))

(defn is-item-completed [returntype item]
  (let [item (u/remove-blanks item)]
    (cond
      (= returntype :return)
      (contains-all? item [:summary :reason])

      (= returntype :repair)
      (contains-all? item [:usage :summary]))))

(defn get-completed-selected-items [returntype items]
  (vec (filter #(is-item-completed returntype %)
         (map u/remove-blanks items))))


(rum/defc item-modal-body < rum/reactive [app-atom config-atom]
  (let [item-index (cmn/curact config-atom :item-index)
        current-atom (rum/cursor-in app-atom [:aftersales])
        selected-index-atom (rum/cursor-in current-atom [:selected-index])
        item-atom (rum/cursor-in current-atom [:order :items item-index])
        returntype (cmn/curact config-atom :type)
        item-reasons (cmn/curact current-atom :item-reasons)
        reason-atom (rum/cursor item-atom :reason)
        item-destinations (get (cmn/curact current-atom :reason->destination) (rum/react reason-atom))
        destination-atom (rum/cursor item-atom :destination)
        chosen-destination (rum/react destination-atom)
        serial-barcode (cmn/curact item-atom :serial-barcode)
        needs-barcode-atom (rum/cursor item-atom :needs-barcode?)]
    (reset! selected-index-atom item-index)
    [:div
     (cards/product-infoblock (cmn/curval item-atom))
     [:div.u-hr]
     (cond
       (= returntype :return)
       [:div
        (forms/select "Reason for return:" reason-atom
          (concat
            [{:value "" :text "- Please Select -"}]
            (map (fn [r] {:text r}) item-reasons)))
        (forms/select "Yuppiechef notes:" (rum/cursor item-atom :internal-reason)
          [{:value "Blank" :text "- Please Select -"}
           {:value "Customer Error" :text "Customer Regret"}
           {:value "Product Page" :text "Product Page"}
           {:value "Aramex" :text "Aramex Problem"}
           {:value "Backend Fault" :text "Fault on Backend"}
           {:value "Poor Quality" :text "Product Quality Poor"}
           {:value "Unwanted Gift" :text "Unwanted Gift"}
           {:value "Warehouse" :text "Warehouse Problem"}])

        (forms/select "Stock Destination:" (rum/cursor item-atom :destination)
          (sort-by :text
            (concat
              [{:value "" :text "- Please Select -"}]
              (map (fn [r] {:text r}) item-destinations))))

        (cond
          (and chosen-destination
            (not= chosen-destination "Stock")
            (not= chosen-destination "Discard")
            (not serial-barcode))
          (do
            (reset! needs-barcode-atom true)
            [:p (or serial-barcode (str "Scan printer to print a serialized barcode and stick it to the box"))])

          :else (reset! needs-barcode-atom false))

        (forms/textarea "Summary of what went wrong:"
          (rum/cursor item-atom :summary))]

       (= returntype :repair)
       (do
         (reset! needs-barcode-atom true)
         (reset! destination-atom "Repair")

         [:div
          (forms/select "Usage:" (rum/cursor item-atom :usage)
            [{:value "" :text "- Please Select -"}
             {:value "0" :text "Domestic"}
             {:value "1" :text "Commercial"}])

          (forms/select "Reason for return:" (rum/cursor item-atom :reason)
            (concat
              [{:value "" :text "- Please Select -"}]
              (map (fn [r] {:text r}) item-reasons)))

          (forms/textarea "Summary of what went wrong:"
            (rum/cursor item-atom :summary))
          [:p (or serial-barcode (str "Scan printer to print a serialized barcode and stick it to the box"))]]))]))

(rum/defc item-modal-footer < rum/reactive [app-atom config-atom]
  (let [item-index (cmn/curact config-atom :item-index)
        item-atom (rum/cursor-in app-atom [:aftersales :order :items item-index])
        returntype (cmn/curact config-atom :type)]
    (grid/button-row
      {:left-text "Close"
       :left-no-icon true
       :left-fn #(grid/dispatch-modal-action app-atom :aftersales/item-modal-close)
       :right-text "Done"
       :right-no-icon true
       :right-fn
       (when (is-item-completed returntype (cmn/curval item-atom))
         #(grid/dispatch-modal-action app-atom :aftersales/item-modal-done))})))

(defmethod flow/barcode-dispatch-modal :aftersales/item-modal [_ app-atom scan]
  (let [current-atom (rum/cursor-in app-atom [:aftersales])
        order-atom (rum/cursor-in current-atom [:order])
        selected-index-atom (cmn/curact current-atom [:selected-index])
        clientorder_id (cmn/curact order-atom :id)
        {:keys [needs-barcode? vid serial-barcode reason summary] :as abc} (cmn/curact current-atom [:order :items selected-index-atom])]
    (comms/send :aftersales/serialized-barcode
      {:details
       {:variation-id vid
        :clientorder-id clientorder_id
        :needs-barcode? needs-barcode?
        :printer scan
        :serial-barcode serial-barcode
        :item-index selected-index-atom
        :reason reason
        :reasontext summary}})))

(defmethod comms/receive :aftersales/serialized-barcode [app-atom e]
  (swap! app-atom assoc-in
    [:aftersales :order :items (:index e) :serial-barcode]
    (:serial-barcode e)))

(defmethod grid/modal-config :aftersales/item-modal [_ _ _]
  {:body item-modal-body
   :footer item-modal-footer})

(defn open-item-modal [app-atom returntype item-index]
  (grid/open-modal app-atom :aftersales/item-modal {:item-index item-index :type returntype}))

(defn special-group-sections [items]
  (->>
    items
    (map-indexed (fn [idx i] (assoc i :idx idx)))
    (sort-by :price)
    reverse
    (group-by :specialgroup/group_number)
    (mapcat
      (fn [[gn is]]
        (concat
          [{:heading
            (if gn
              (str "Special bundle " gn ":")
              (str "Other items:"))}]
          is)))))

(rum/defc aftersales-screen-order-items < rum/reactive
  [app-atom]
  (let [aftersales-atom (rum/cursor-in app-atom [:aftersales])
        case-atom (rum/cursor-in app-atom [:aftersales :order])
        returntype (cmn/curact aftersales-atom :type)
        selected-items (get-selected-items (cmn/curact case-atom :items))
        discounts? (cmn/curact case-atom :discounts)
        totals (cmn/curact case-atom :totals)
        completed-items (get-completed-selected-items returntype selected-items)
        next-enabled (and (> (count selected-items) 0) (= (count selected-items) (count completed-items)))
        article-bundleup (cmn/curact aftersales-atom [:customer :lookup :article-bundleup])

        group-items
        (if (pos? (:total-groupdiscounts totals))
          (special-group-sections (cmn/curact case-atom :items))
          (map-indexed (fn [idx i] (assoc i :idx idx)) (cmn/curact case-atom :items)))]
    (aftersales-screen-wrapper app-atom :items
      [[:div
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           (cmn/curact case-atom :ref)
           [:span.u-hidden-from-view " - "]
           [:span.heading__subtext "Placed: " (cmn/curact case-atom :dateplaced)]]
          (cond
            (and discounts? (= :return returntype))
            (feedback/feedback :info "" "This order had a discount or voucher. Refunds might need to go through Store Manager or Customer Support.")

            (and (not (nil? (:total-groupdiscounts totals))) (pos? (:total-groupdiscounts totals)))
            (feedback/feedback :info "Special Bundle Discount Info"
              [:span "This order has items from a bundle discount special. "
               [:a.text-link
                {:href "#"
                 :on-click
                 #(grid/message-modal app-atom
                    {:title (:title article-bundleup)
                     :text
                     [:div
                      [:div
                       {:dangerouslySetInnerHTML
                        {:__html
                         (->
                           (:body article-bundleup)
                           (str/replace #"[<]a " "<i ")
                           (str/replace #"[<][/]a[>]" "</i>"))}}]]
                     :confirm-text "Close"
                     :modal-type :standard-modal})} "Learn More"]]))]
         [:div.slats
          (map
            (fn [i]
              (if (:heading i)
                [:h3.slat.sub-heading-slat
                 [:span.sub-heading__text (:heading i)]]
                (slats/item-return-slat :edit i
                  {:selected-atom (rum/cursor-in case-atom [:items (:idx i) :selected])
                   :selected-fn #(open-item-modal app-atom returntype (:idx i))})))
            group-items)]]]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when next-enabled
           (if (= returntype :return)
             #(t/transition-next app-atom :returns/gift-check)
             #(t/transition-next app-atom :returns/details)))}))))

(defmethod flow/render-screen :returns/items [app-atom screen]
  (aftersales-screen-order-items app-atom))

(defmethod flow/barcode-dispatch-screen :returns/items [_ app-atom scan]
  (grid/dispatch-action app-atom :returns/item-scan {:scan scan}))

(defmethod grid/action :returns/item-scan [app-atom {:keys [scan]} _]
  (let [{:keys [order] :as aftersale} (:aftersales @app-atom)]
    (loop [[h & t] (:items order)
           idx 0]
      (cond
        (nil? h) nil
        (= scan (:barcode h))
        (do
          (swap! app-atom assoc-in [:aftersales :order :items idx :selected] true)
          (open-item-modal app-atom (:type aftersale) idx))
        :else
        (recur t (inc idx))))))

(rum/defc aftersales-screen-gift-return-check < rum/reactive [app-atom]
  (let [customer-atom (rum/cursor-in app-atom [:aftersales :customer])
        customer-details (cmn/curval customer-atom)
        next-enabled? (u/presence (:hidden customer-details))]

    (aftersales-screen-wrapper app-atom :gift-check
      [[:div
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "Return type"]

          [:div.form-field
           (forms/radio "Customer return"
             0
             (rum/cursor customer-atom :hidden)
             {:description
              "Standard return, will show in my account"})]

          [:div.form-field
           (forms/radio "Gift recipient return"
             1
             (rum/cursor customer-atom :hidden)
             {:description
              "Hidden from gift purchaser's account"})]]]]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when next-enabled?
           (if (= (cmn/curact customer-atom :hidden) 1)
             #(grid/dispatch-action app-atom :aftersales/gift-return {})
             #(grid/dispatch-action app-atom :aftersales/normal-return {})))}))))

(defmethod grid/action :aftersales/normal-return [app-atom config _]
  (let [customer-details @(rum/cursor-in app-atom [:aftersales :customer :lookup])]

    (swap! app-atom update-in [:aftersales :customer]
      #(merge %
         {:firstname (:firstname customer-details)
          :lastname (:lastname customer-details)
          :email (:email customer-details)
          :cell (:cell customer-details)}))

    (t/transition-next app-atom :returns/details)))

(defmethod grid/action :aftersales/gift-return [app-atom config _]
  (swap! app-atom update-in [:aftersales :customer]
    #(dissoc % :firstname :lastname :email :cell))

  (t/transition-next app-atom :returns/details))

(defmethod flow/render-screen :returns/gift-check [app-atom screen]
  (aftersales-screen-gift-return-check app-atom))

(def aftersales-refund-types
  {:voucher "Yuppiechef Voucher" :refund "A refund back into your account" :exchange "Exchange for New Item(s)"})

(rum/defc aftersales-screen-customer-details < rum/reactive
  [app-atom]
  (let [aftersales-atom (rum/cursor-in app-atom [:aftersales])
        customer-atom (rum/cursor-in app-atom [:aftersales :customer])
        customer-details (cmn/curval customer-atom)
        order-atom (rum/cursor-in app-atom [:aftersales :order])
        payment-types (cmn/curact order-atom :payment-types)
        returntype (cmn/curact aftersales-atom :type)
        next-enabled?
        (if (= returntype :repair)
          (contains-all? (u/remove-blanks customer-details) [:firstname :lastname :email :cell])
          (contains-all? (u/remove-blanks customer-details) [:firstname :lastname :email :cell :refundtype]))]

    (aftersales-screen-wrapper app-atom :details
      [[:div
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "Complete customer details"]
          (forms/split-input-field
            ["First Name:" "e.g. Jane" (rum/cursor customer-atom :firstname) {:type :user}]
            ["Last Name:" "e.g. Smith" (rum/cursor customer-atom :lastname) {:type :user}])
          (forms/input "Email Address:" "e.g. jane.smith@domain.com"
            (rum/cursor customer-atom :email)
            {:type :email
             :show-email-helpers true})
          (forms/input "Cellphone Number:" "e.g. 021 000 0000"
            (rum/cursor customer-atom :cell)
            {:type :tel})
          (forms/textarea "Customer Notes:"
            (rum/cursor customer-atom :notes))

          (when (= returntype :return)
            (cond
              (= (cmn/curact customer-atom :hidden) 1)
              (forms/select "Preferred Refund Method:" (rum/cursor customer-atom :refundtype)
                [{:text " - Please Select - " :value ""}
                 {:text "Yuppiechef Voucher" :value "Voucher"}
                 {:text "Exchange for New Item(s)" :value "Replacement"}] {})

              :else
              (forms/select "Preferred Refund Method:" (rum/cursor customer-atom :refundtype)
                [{:text " - Please Select - " :value ""}
                 {:text "Yuppiechef Voucher" :value "Voucher"}
                 {:text "Refund" :value "Refund"}
                 {:text "Exchange for New Item(s)" :value "Replacement"}] {})))

          [:div.u-margin-top-16.u-bg-ghost
           [:b
            (forms/field-label (str "Payment Methods: " (apply u/glue ", " payment-types)) {})]]]]]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when next-enabled?
           #(grid/dispatch-action app-atom :aftersales/capture-aftersales-case {}))}))))

(defmethod flow/render-screen :returns/details [app-atom screen]
  (aftersales-screen-customer-details app-atom))

(defmethod grid/action :aftersales/capture-aftersales-case [app-atom config _]
  (let [{:keys [customer order] :as aftersales} (:aftersales @app-atom)]
    (comms/send :pos/submit-return-details
      {:details
       {:checked-items
        (filter (comp true? :selected) (:items order))
        :order (select-keys order [:id])}})))

(defmethod comms/receive :pos/return-refund-method [app-atom e]
  (t/transition-next app-atom :returns/summary)
  (swap! app-atom assoc-in [:aftersales :refund] (:refund e)))

(rum/defc returncase-summary < rum/reactive [customer-atom refund-atom]
  (let [refund (rum/react refund-atom)
        line
        (fn [title amount]
          (when (and amount (not (zero? amount)))
            [:li.order-calc__item
             [:span.order-calc__item-name (str title ":")]
             [:span.order-calc__item-value
              {:class (when (neg? amount) ["u-text-status-discount"])}
              (when (neg? amount) "-")
              "R" (u/number-format (Math/abs amount) 2 "." ",")]]))]
    [:div
     {:class (u/bem :section [:medium])}
     [:h3.u-margin-top-16
      {:class (u/bem :heading [:standard :flush])}
      "Return Totals:"]
     (into
       [:ul.order-calc]
       (concat
         [(line "Selected Items" (:selected refund))]
         [(when (:selected-discounts refund)
            [(line "Selected Discounts" (:selected-discounts refund))
             (line "Total" (+ (:selected refund) (:selected-discounts refund)))])]
         [[:li.order-calc__item
           [:span.order-calc__item-name "Preferred refund:"]
           [:span.order-calc__item-value
            [:b (get aftersales-refund-types
                  (keyword (str/lower-case (or (cmn/curact customer-atom :refundtype) ""))))]]]]))

     [:div.u-hr]
     [:h3.u-margin-top-16
      {:class (u/bem :heading [:standard :flush])}
      "Original Order Totals:"]

     [:ul.order-calc
      (line "Order Payments" (:payments refund))
      (line "Order Discounts" (:calculated-discounts refund))]]))

(rum/defc aftersales-screen-summary < rum/reactive [app-atom]
  (let [aftersales-atom (rum/cursor-in app-atom [:aftersales])
        customer-atom (rum/cursor-in app-atom [:aftersales :customer])
        orderstatus (cmn/curact app-atom [:aftersales :order :status])
        caseitems-atom (rum/cursor-in app-atom [:aftersales :order :items])

        selected-items (get-selected-items (rum/react caseitems-atom))
        supervisor (cmn/curact aftersales-atom :supervisor)
        refund (cmn/curact aftersales-atom :refund)
        returntype (cmn/curact aftersales-atom :type)
        all-items-refundable? (= (:selected refund) (:refundable refund))
        cs-action
        (or
          (:has-credit-items? refund)
          (= returntype :repair)
          (not (or supervisor (:allowed refund)))
          (not (contains? #{"Sent to Courier" "Delivered"} orderstatus)))]
    (aftersales-screen-wrapper app-atom :summary
      [[:div
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "Summary of " (name returntype) " case"]]
         (when cs-action
           [:div
            {:class (u/bem :section [:standard])}
            (cond
              (:has-credit-items? refund)
              (feedback/feedback :warning "" "Return must be escalated to CS for assessment. Additional Note: Return has item(s) for credit.")

              (and (= :return returntype) (:possible-discounts refund) (not all-items-refundable?))
              (feedback/feedback :warning "" "Return must be escalated to Store Manager for immediate action or CS for assessment. Additional Note: Original order has a discount or voucher.")

              (not (contains? #{"Sent to Courier" "Delivered"} orderstatus))
              (feedback/feedback :warning "" "This case must be escalated to Store Manager for immediate action or CS for assessment. Additional Note: Original order has not yet been processed, so would have to be manually adjusted to compensate.")

              :else
              (feedback/feedback :warning "" "This case must be escalated to Store Manager for immediate action or CS for assessment."))])

         [:div
          (when cs-action {:class :u-margin-top-24})
          (map
            (fn [i]
              (slats/item-return-slat :view i {}))
            selected-items)]]
        (when-not (= returntype :repair)
          (returncase-summary customer-atom (rum/cursor aftersales-atom :refund)))]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn
         (cond
           cs-action
           #(t/transition-next app-atom :returns/print)

           :else
           #(t/transition-next app-atom :returns/auth-payments))}))))

(defmethod flow/render-screen :returns/summary [app-atom screen]
  (aftersales-screen-summary app-atom))

(defmethod flow/barcode-dispatch-screen :returns/auth-payments [_ app-atom scan]
  (grid/dispatch-action app-atom :returns/supervisor-scan {:scan scan}))

(defmethod flow/barcode-dispatch-screen :returns/summary [_ app-atom scan]
  (grid/dispatch-action app-atom :returns/supervisor-scan {:scan scan}))

(defmethod grid/action :returns/supervisor-scan [app-atom {:keys [scan]}]
  (toaster/open-toast app-atom :processing "Authenticating" {})
  (comms/send :pos/supervisor-scan {:scan scan}))

(defmethod comms/receive :pos/supervisor-scan [app-atom e]
  (toaster/open-toast app-atom :success "Supervisor Authenticated." {})
  (swap! app-atom assoc-in [:aftersales :supervisor] (:supervisor e))
  (t/transition-next app-atom :returns/payments))


(rum/defc aftersales-screen-auth-payments < rum/reactive
  [app-atom]
  (let [aftersales-atom (rum/cursor-in app-atom [:aftersales])
        refund-atom (rum/cursor aftersales-atom :refund)
        customer (cmn/curact aftersales-atom :customer)
        refund (rum/react refund-atom)
        all-items-refundable? (= (:selected refund) (:refundable refund))
        returntype (cmn/curact aftersales-atom :type)
        type-refund? (= "Refund" (:refundtype customer))
        mobicred? (:mobicred? refund)
        payflex? (:payflex? refund)
        no-cash? (zero? (:cash refund))
        no-card? (zero? (:card refund))
        mobicred-escalate-cs? (and mobicred? type-refund?)
        payflex-escalate-cs? (and payflex? type-refund?)]

    (aftersales-screen-wrapper app-atom :auth-payments
      [[:div.u-margin-top-24
        (cond
          mobicred-escalate-cs?
          [:div
           {:class (u/bem :section [:medium])}
           [:div.u-margin-top-24
            (feedback/feedback :warning "" "This order was purchased using Mobicred. The return will need to be submitted to Customer Support.")]]

          payflex-escalate-cs?
          [:div
           {:class (u/bem :section [:medium])}
           [:div.u-margin-top-24
            (feedback/feedback :warning "" "This order was purchased using Payflex. The return will need to be submitted to Customer Support.")]]

          :else
          [:div
           {:class (u/bem :section [:medium])}
           [:h2.u-text-center
            {:class (u/bem :heading [:standard])}
            "Scan manager tag to auth refund"]
           [:div
            [:i.u-block-center
             {:class
              (u/bem
                :icon
                [:2-1 :barcode-scan :light-force :enormous :block])}]]

           [:div.u-margin-top-24
            (cond
              (and (= :return returntype) (:possible-discounts refund) all-items-refundable?)
              (feedback/feedback :warning "" "The original order had a discount or voucher. For immediate refund, Store Manager must calculate the amount. Else submit the return to Customer Support.")

              :else
              (feedback/feedback :warning "" "For immediate refund, Store Manager must scan their tag to authorise. Else submit the return to Customer Support."))]])]]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(t/transition-next app-atom :returns/print)
         :right-text
         "Submit to CS"}))))

(defmethod flow/render-screen :returns/auth-payments [app-atom screen]
  (aftersales-screen-auth-payments app-atom))

;; ========= Refund Amount Modal ===========================
(rum/defc amount-refund-input < rum/reactive [config-atom max-value]
  (let [amount-atom (rum/cursor config-atom :amount)
        error
        (when (> (u/parseFloat (rum/react amount-atom)) max-value)
          (str "Maximum amount of R" (u/number-format max-value) " exceeded."))
        hint (or error (str "Max refund amount is R" (u/number-format max-value)))]
    (forms/input "Amount to Refund:" (str "(up to R" (u/number-format max-value) ")") amount-atom
      {:type :currency
       :hint hint
       :error error})))

(defmethod grid/action :aftersales/amount-modal-confirm [app-atom config _]
  (let [amount-text (:amount config)
        amount (u/parseFloat amount-text)
        amount-atom (rum/cursor-in app-atom [:aftersales :refund (:amount-key config)])
        supervisor (get-in @app-atom [:aftersales :supervisor])]
    (println "amount modal confirm")
    (if
      (and
        (u/presence amount-text)
        (or (<= amount (:max-value config)) supervisor)
        (pos? amount))
      (do
        (reset! amount-atom amount)
        (println "amount reset")
        (grid/close-modal app-atom))
      (toaster/open-toast app-atom :error "Invalid amount." {}))))

(rum/defc amount-modal-body < rum/reactive [app-atom config-atom]
  (let [config (rum/react config-atom)
        max-value (:max-value config)
        card4-key (:card4-key config)
        card4-atom (when card4-key (rum/cursor-in app-atom [:aftersales :refund card4-key]))]

    [:div.section
     [:h2.heading.heading--standard (str "Capture " (cmn/curact config-atom :title) " Refund")]
     (amount-refund-input config-atom max-value)
     (when card4-atom
       (forms/input "Last 4 digits of card:" ""
         card4-atom {:type :text-number :max-length 4}))]))

(rum/defc amount-modal-footer < rum/reactive [app-atom config-atom]
  (grid/button-row
    {:single-text "Capture refund"
     :single-style :primary
     :single-no-icon true
     :single-fn
     #(grid/dispatch-modal-action app-atom :aftersales/amount-modal-confirm
        {} {:prevent-closing true})
     :disabled (cmn/curact config-atom :disabled)}))

(defmethod grid/modal-config :aftersales/amount-modal [_ _ _]
  {:body amount-modal-body
   :footer amount-modal-footer
   :modal-type :alert})

(defn open-amount-modal [app-atom title amount-key max-value & [card4-key]]
  (let [amount-atom (rum/cursor-in app-atom [:aftersales :refund amount-key])]
    (grid/open-modal app-atom :aftersales/amount-modal
      {:title title :amount @amount-atom :amount-key amount-key
       :max-value max-value :card4-key card4-key})))

(rum/defc payment-list < rum/reactive [payments cancel-fn]
  (let [slats
        (when-not (empty? payments)
          (->>
            payments
            (filter (comp pos? u/parseFloat :amount))
            (map
              (fn [p]
                (let [typedef (get payment/type-lookup (:pmttype p))]
                  (payment/payment-line
                    (:name typedef) "" (int (* 100 (:amount p))) (:icon typedef) (:icon-size typedef)
                    :dots-menu nil :muted
                    #(cancel-fn p)))))))]
    (if (empty? slats)
      [:div]
      (into
        [:nav.payment-options-list
         {:class (u/bem :slats [:muted])}
         [:h3.heading-slat {:class (u/bem :slat [:muted])} "Payments received:"]]
        slats))))

(defmethod grid/action :aftersales/refund-clear-confirm [app-atom config _]
  (swap! app-atom update-in [:aftersales :refund] dissoc (keyword (str (str/lower-case (:pmttype (:payment config))) "-amount"))))

(rum/defc aftersales-screen-payments < rum/reactive
  [app-atom]
  (let [aftersales-atom (rum/cursor-in app-atom [:aftersales])
        supervisor (cmn/curact aftersales-atom :supervisor)
        refund-atom (rum/cursor aftersales-atom :refund)
        refund (rum/react refund-atom)

        ;; Providers whose payments can't be refunded as cash/card in store —
        ;; those refunds go through Customer Support (voucher stays available).
        disabled-provider
        (cond
          (:mobicred? refund) "Mobicred"
          (:payflex? refund) "Payflex")

        owing
        (- (:total refund) (u/parseFloat (:cash-amount refund))
          (u/parseFloat (:card-amount refund))
          (u/parseFloat (:voucher-amount refund)))]
    (aftersales-screen-wrapper app-atom :payments
      [[:div.u-margin-top-24
        [:div
         {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Refunds for " (name (cmn/curact aftersales-atom :type)) " case"]]
        (when
          (or supervisor (pos? owing))
          [:nav.payment-options-list.slats
           (when (or (pos? (:cash refund)) supervisor)
             (payment/payment-option-slat "Cash"
               (if disabled-provider
                 (str "Disabled - " disabled-provider)
                 (str "(up to R" (u/number-format (min owing (:cash refund))) ")"))
               nil :cash :3-3 :arrow-right :2-1
               #(open-amount-modal app-atom "Cash"
                  :cash-amount (min owing (:cash refund)))
               :disabled (some? disabled-provider)))

           (when (or (pos? (:card refund)) supervisor)
             (payment/payment-option-slat "Card"
               (if disabled-provider
                 (str "Disabled - " disabled-provider)
                 (str "(up to R" (u/number-format (min owing (:card refund))) ")"))
               nil :credit-card :2-1 :arrow-right :2-1
               #(open-amount-modal app-atom "Credit Card"
                  :card-amount (min owing (:card refund)) :card-last4)
               :disabled (some? disabled-provider)))

           (when (or (pos? owing) supervisor)
             (payment/payment-option-slat "Voucher" (str "(up to R" (u/number-format owing) ")") nil :gift-card :3-3 :arrow-right :2-1
               #(open-amount-modal app-atom "Voucher"
                  :voucher-amount owing)))])

        (payment-list
          [{:pmttype "Cash" :amount (:cash-amount refund)}
           {:pmttype "Card" :amount (:card-amount refund)}
           {:pmttype "Voucher" :amount (:voucher-amount refund)}]
          #(grid/confirm-modal app-atom
             {:title "Confirm"
              :text "Are you sure you want to clear this refund?"
              :negative true
              :confirm-key :aftersales/refund-clear-confirm
              :payment %}))

        (returncase-summary (rum/cursor aftersales-atom :customer) refund-atom)]]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn
         (when-not (pos? owing)
           #(t/transition-next app-atom :returns/print))
         :right-plain (pos? owing)
         :right-text
         (cond
           (pos? owing)
           (str "Owed R" (u/number-format owing 2))
           :else
           "Next")}))))

(defmethod flow/render-screen :returns/payments [app-atom screen]
  (aftersales-screen-payments app-atom))



(rum/defc aftersales-screen-print < rum/reactive
  [app-atom]
  (let [aftersales-atom (rum/cursor-in app-atom [:aftersales])
        supervisor (cmn/curact aftersales-atom :supervisor)
        refund (cmn/curact aftersales-atom :refund)
        returntype (cmn/curact aftersales-atom :type)
        cs-action (or (= returntype :repair) (not (or supervisor (:allowed refund))))]
    (aftersales-screen-wrapper app-atom :print
      [[:div
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "Submit " (name returntype)]
          [:div.step-graphic-wrapper.u-bg-blue-lighter
           [:i.u-block-center
            {:class (u/bem :icon [:2-2 :barcode-scan :large :block])}]]

          [:div.u-margin-top-24
           [(if cs-action
              [:p.paragraph.paragraph--flush.u-text-center
               "This case will be submitted to Customer Support for review. Customer will be contacted."])]]]]]]

      [[:p.paragraph.paragraph--flush.u-text-center
        [:i. {:class (u/bem :icon [:inline :in-copy-left :barcode-scan :2-1])}]
        "To submit " (name returntype) " scan printer"]
       (when (u/has-device-printer?)
         [:div.u-margin-bottom-16.u-text-center
          (buttons/button
            "Use Device Printer"
            (fn []
              (swap! app-atom assoc-in [:aftersales :device-printing] true)
              (t/transition-next app-atom :returns/device-print))
            {:icon-right :print :raised true :large true :primary true})])]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Printer"
         :right-plain true}))))

(defmethod flow/render-screen :returns/print [app-atom screen]
  (aftersales-screen-print app-atom))

(defmethod flow/barcode-dispatch-screen :returns/print [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersales/submit-aftersales-case {:scan scan}))

(rum/defc aftersales-device-print-screen < rum/reactive
  [app-atom]
  (let [aftersales-atom (rum/cursor-in app-atom [:aftersales])
        {:keys [merchant-printed customer-printed]} (rum/react aftersales-atom)
        both-printed? (and merchant-printed customer-printed)]
    (aftersales-screen-wrapper app-atom :print
      [[:div
        [:div.u-margin-top-24
         [:div {:class (u/bem :section [:medium])}
          [:h2.u-text-center {:class (u/bem :heading [:standard])}
           "Print Slips"]
          [:p.u-text-center {:class (u/bem :paragraph [:flush])}
           "Print both copies to continue"]

          [:div.u-margin-top-24
           (when merchant-printed
             (feedback/feedback :success "Merchant Copy" "Printed"))
           [:div.u-margin-top-16.u-text-center
            (buttons/button
              (if merchant-printed "Reprint Merchant Copy" "Print Merchant Copy")
              (fn []
                (swap! app-atom assoc-in [:aftersales :printing-copy] :merchant)
                (grid/dispatch-action app-atom :aftersales/submit-aftersales-case
                  {:scan "DEVICE-PRINTER" :merchant true}))
              {:icon-right :print :raised true :large true
               :primary (not merchant-printed) :secondary merchant-printed})]]

          [:div.u-margin-top-24
           (when customer-printed
             (feedback/feedback :success "Customer Copy" "Printed"))
           [:div.u-margin-top-16.u-text-center
            (buttons/button
              (if customer-printed "Reprint Customer Copy" "Print Customer Copy")
              (fn []
                (swap! app-atom assoc-in [:aftersales :printing-copy] :customer)
                (grid/dispatch-action app-atom :aftersales/submit-aftersales-case
                  {:scan "DEVICE-PRINTER" :merchant false}))
              {:icon-right :print :raised true :large true
               :primary (not customer-printed) :secondary customer-printed})]]]]]]

      []

      (grid/pos-call-to-action
        {:single-text "Done"
         :single-fn
         (when both-printed?
           (fn []
             (swap! app-atom update :aftersales dissoc :device-printing)
             (t/transition-next app-atom :returns/finished)))
         :single-style :call-to-action}))))

(defmethod flow/render-screen :returns/device-print [app-atom screen]
  (aftersales-device-print-screen app-atom))

(defmethod flow/barcode-dispatch-screen :returns/device-print [_ app-atom scan]
  (toaster/open-toast app-atom :warning "Use the print buttons on screen" {}))

(defmethod grid/action :aftersales/submit-aftersales-case [app-atom {:keys [scan merchant]}]
  (let [{:keys [customer order refund supervisor uuid] :as aftersale} (:aftersales @app-atom)
        total (reduce + 0 (map refund [:cash-amount :card-amount :voucher-amount]))
        pending (- (:total refund) total)]
    (toaster/open-toast app-atom :processing "Submitting" {})
    (comms/send :pos/submit-return-refund
      (cond->
        {:scan scan
         :details
         {:checked-items (filter (comp true? :selected) (:items order))
          :user (dissoc customer :orders :lookup)
          :order (select-keys order [:id])
          :refund (assoc refund :total total :pending pending)
          :refundtype (:refundtype customer)
          :returntype (if (= (:type aftersale) :return) "Return" "Repair")
          :hidden (:hidden customer)
          :notes (:notes customer)}
         :supervisor supervisor
         :printername scan
         :uuid uuid}
        (some? merchant) (assoc :merchant merchant)))))


(defmethod comms/receive :pos/return-complete [app-atom e]
  (if (get-in @app-atom [:aftersales :device-printing])
    (let [printing-copy (get-in @app-atom [:aftersales :printing-copy])]
      (toaster/open-toast app-atom :success "Printed" {})
      (swap! app-atom
        (fn [state]
          (cond-> state
            true
            (assoc-in [:aftersales :result] e)

            (= printing-copy :merchant)
            (assoc-in [:aftersales :merchant-printed] true)

            (= printing-copy :customer)
            (assoc-in [:aftersales :customer-printed] true)

            true
            (update :aftersales dissoc :printing-copy)))))
    (do
      (t/transition-next app-atom :returns/finished)
      (toaster/open-toast app-atom :success "Successful" {})
      (swap! app-atom assoc-in [:aftersales :result] e))))

(rum/defc aftersales-screen-finished < rum/reactive
  [app-atom]
  (let [aftersales-atom (rum/cursor-in app-atom [:aftersales])]
    (aftersales-screen-wrapper app-atom :finished
      [[:div
        [:div.u-margin-top-24
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           (if (= :return (cmn/curact aftersales-atom :type)) "Return" "Repair")
           " submitted"]
          [:i.u-block-center
           {:class (u/bem :icon [:3-3 :success :enormous :block])}]
          [:div.u-margin-top-24
           [:p.u-text-center
            {:class (u/bem :paragraph [:large])}
            [:b "Reference: " (cmn/curact aftersales-atom [:result :ycr])]]]]]]]

      [[:p.paragraph.paragraph--flush.u-text-center
        "Scan printer to reprint slip"]]

      (grid/pos-call-to-action
        {:single-fn #(t/transition-next app-atom :main-menu)}))))


(defmethod flow/render-screen :returns/finished [app-atom screen]
  (aftersales-screen-finished app-atom))

(defmethod flow/barcode-dispatch-screen :returns/finished [_ app-atom scan]
  (grid/dispatch-action app-atom :aftersales/submit-aftersales-case {:scan scan}))

